import React, { useContext } from "react";
import { ProvideInsuranceForm } from "@app/components/provideInsuranceForm";
import { StepperContent } from "@app/components/ui/layout/stepperContent";
import { SubSteps } from "@app/pages/private/simpleOrder/paymentMethod/paymentMethod";
import { StepperContext } from "@natera/stepper";
import { defineMessages, useIntl } from "react-intl";
import {
  MultiplePaymentMethodType,
  PaymentMethodType,
  SimpleOrderStepperContext,
} from "@app/provider/simpleOrder/SimpleOrderStepperProvider";
import { Steps } from "@app/pages/private/simpleOrder";
import {
  getPaymentMethodInfoSubStepsData,
  isCommercialOrGovernmentInsuranceFirst,
  isCommercialOrGovernmentInsuranceSecond,
} from "@app/utils";

const messages = defineMessages({
  provideCommercialStepHeaderTitle: {
    id: "provideCommercialStepHeaderTitle",
    defaultMessage: "Payment Method",
  },
  provideCommercialStepHeaderSubTitle: {
    id: "provideCommercialStepHeaderSubTitle",
    defaultMessage: "Enter insurance information",
  },
});

type Props = {
  onConfirm?: (data?: unknown) => void;
};

const ProvideCommercialStep: React.FC<Props> = ({ onConfirm }) => {
  const intl = useIntl();

  const { goBack, resolve, getCurrentStep, getStep } =
    React.useContext(StepperContext);
  const currentStepId = getCurrentStep()?.stepId;

  const { getSubStepData, resolveSubStep } = useContext(
    SimpleOrderStepperContext
  );
  const subStepsData = getSubStepData(Steps.PAYMENT_METHOD) as
    | PaymentMethodType
    | MultiplePaymentMethodType;

  const isInsuranceFirstStep =
    isCommercialOrGovernmentInsuranceFirst(currentStepId);
  const isInsuranceSecondStep =
    isCommercialOrGovernmentInsuranceSecond(currentStepId);

  const commercialStepData = getPaymentMethodInfoSubStepsData(
    subStepsData,
    isInsuranceFirstStep,
    isInsuranceSecondStep
  );

  const handleSubmit = (memberId: string) => {
    let subStepDataWithMemberId;
    if (isInsuranceFirstStep) {
      subStepDataWithMemberId = {
        paymentMethodInfo: {
          first: {
            paymentMethodInfo: {
              ...(subStepsData as MultiplePaymentMethodType)?.paymentMethodInfo
                ?.first?.paymentMethodInfo,
              memberId,
            },
          },
        },
      };
    } else if (isInsuranceSecondStep) {
      subStepDataWithMemberId = {
        paymentMethodInfo: {
          second: {
            paymentMethodInfo: {
              ...(subStepsData as MultiplePaymentMethodType)?.paymentMethodInfo
                ?.second?.paymentMethodInfo,
              memberId,
            },
          },
        },
      };
    } else {
      subStepDataWithMemberId = {
        paymentMethodInfo: { memberId },
      };
    }

    resolveSubStep({
      stepId: Steps.PAYMENT_METHOD,
      subStepData: subStepDataWithMemberId,
    });

    resolve({ memberId });
    const needToAddSecondMultipleStep = !getStep(SubSteps.MULTIPLE_SECOND);
    if (needToAddSecondMultipleStep) {
      onConfirm && onConfirm();
    }
  };

  const handleBack = () => {
    goBack();
  };

  return (
    <StepperContent
      title={intl.formatMessage(messages.provideCommercialStepHeaderTitle)}
      subTitle={intl.formatMessage(
        messages.provideCommercialStepHeaderSubTitle
      )}
    >
      <ProvideInsuranceForm
        defaultValue={commercialStepData?.memberId}
        onSubmit={handleSubmit}
        goBack={handleBack}
      />
    </StepperContent>
  );
};

export default ProvideCommercialStep;
